<template>
    <div>
        <div class="side">
            <ul>
                <li>{{menu.title}}</li>
                <router-link v-for="item in menu.children" :key="item.path" tag="li" :class="[item.mete?'textBold':'hoverStyle']" :to="item.mete?'':'/'+menu.path+'/'+item.path">{{item.text}}</router-link>
            </ul>
        </div>
    </div>
</template>

<script>

import { mapState } from "vuex";
export default {
    props: ['menuName'],
    data() {
        return {
            // menu: 'palletBank'
        }
    },
    computed: {
        menu() {
            return this.$store.state.footerRouter[this.menuName]
        }
    }
}
</script>

<style lang="less" scoped>
.side {
    width: 136px;
    height: 389px;
    background: url("~assets/image/index-img/gray04.png") no-repeat;
    margin-top: 20px;
    ul {
        padding-top: 15px;
        margin-left: 20px;
        li:first-child {
            font-size: 18px;
            font-weight: bold;
        }
        li {
            margin-top: 12px;
            font-size: 16px;
            font-weight: bold;
        }
        .hoverStyle:hover{
                cursor: pointer;
                // color:#ff9000
        }
        .textBold {
            font-size: 18px;
            font-weight: bold;
            color: #2c3e50;
        }
    }
}
.activeClass {
    color: #ff9000;
}
.router-link-active {
    color: #ff9000;
}
</style>